// extracted by mini-css-extract-plugin
export var divider = "_xi-0";